import {noop, omit} from "@pg-mono/nodash";

import {hitGTMEcommercePurchase} from "../../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_purchase";
import {useAppDispatch} from "../../../store/hooks";
import {ViewType} from "../../../view_type/ViewType";
import {applicationLeadDataApi} from "../../api/application_lead_data_api";
import {gtmInquiryOnApplicationSuccess} from "../../tracking/lead/gtm_inquiry_on_application_success";
import {IApplicationReducerData} from "../../types/IApplicationReducerData";
import {ILeadModalLeadType} from "../../types/lead/ILeadModalLeadType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {getApplicationSourceSectionDisplay} from "../../utils/form/application_form_source";

export const useTrackRecommendedPropertiesApplication = () => {
    const dispatch = useAppDispatch();

    return (
        applications: ApplicationMultiLeadRecommendedPropertyType[],
        viewType: ViewType | null,
        leadType: ILeadModalLeadType,
        recommendationsWithPriceFilter: boolean,
        sourceSection?: string
    ): void => {
        // We need to fetch property offer data in order to make GTM event after application submit success
        Promise.all(
            applications.map(([application]) =>
                dispatch(applicationLeadDataApi.endpoints.getApplicationOfferDetail.initiate({offerId: application.offer})).unwrap()
            )
        ).then((offers: unknown[]) => {
            offers.forEach((offer: unknown, index: number) => {
                // Order of response from Promise.all method is preserved, so we can get value from `applications` basing on the index
                const [application, recommendedProperty] = applications[index];

                //GTM purchase event
                const data = {
                    offer: {detail: offer},
                    vendor: {detail: recommendedProperty.offer.vendor},
                    property: {detail: omit(recommendedProperty, ["offer"])}
                } as unknown as IApplicationReducerData;

                const customSourceSection =
                    sourceSection ||
                    `${getApplicationSourceSectionDisplay(application.source_section)} - ${recommendationsWithPriceFilter ? "low" : "similar"}`;
                gtmInquiryOnApplicationSuccess(application, data, viewType, leadType, true, noop(), customSourceSection);
                hitGTMEcommercePurchase(data, viewType, leadType, customSourceSection, application);
            });
        });
    };
};
import {noop, omit} from "@pg-mono/nodash";

import {hitGTMEcommercePurchase} from "../../../offer/tracking/ecommerce_events/hit_gtm_ecommerce_purchase";
import {useAppDispatch} from "../../../store/hooks";
import {ViewType} from "../../../view_type/ViewType";
import {applicationLeadDataApi} from "../../api/application_lead_data_api";
import {gtmInquiryOnApplicationSuccess} from "../../tracking/lead/gtm_inquiry_on_application_success";
import {IApplicationReducerData} from "../../types/IApplicationReducerData";
import {ILeadModalLeadType} from "../../types/lead/ILeadModalLeadType";
import {ApplicationMultiLeadRecommendedPropertyType} from "../../types/multi_lead/ApplicationMultiLeadRecommendedPropertyType";
import {getApplicationSourceSectionDisplay} from "../../utils/form/application_form_source";

export const useTrackRecommendedPropertiesApplication = () => {
    const dispatch = useAppDispatch();

    return (
        applications: ApplicationMultiLeadRecommendedPropertyType[],
        viewType: ViewType | null,
        leadType: ILeadModalLeadType,
        recommendationsWithPriceFilter: boolean,
        sourceSection?: string
    ): void => {
        // We need to fetch property offer data in order to make GTM event after application submit success
        Promise.all(
            applications.map(([application]) =>
                dispatch(applicationLeadDataApi.endpoints.getApplicationOfferDetail.initiate({offerId: application.offer})).unwrap()
            )
        ).then((offers: unknown[]) => {
            offers.forEach((offer: unknown, index: number) => {
                // Order of response from Promise.all method is preserved, so we can get value from `applications` basing on the index
                const [application, recommendedProperty] = applications[index];

                //GTM purchase event
                const data = {
                    offer: {detail: offer},
                    vendor: {detail: recommendedProperty.offer.vendor},
                    property: {detail: omit(recommendedProperty, ["offer"])}
                } as unknown as IApplicationReducerData;

                const customSourceSection =
                    sourceSection ||
                    `${getApplicationSourceSectionDisplay(application.source_section)} - ${recommendationsWithPriceFilter ? "low" : "similar"}`;
                gtmInquiryOnApplicationSuccess(application, data, viewType, leadType, true, noop(), customSourceSection);
                hitGTMEcommercePurchase(data, viewType, leadType, customSourceSection, application);
            });
        });
    };
};
